import React from 'react';
import '../styles/FractionalCMO.css';
import cmoIcon from '../assets/cmo-icon.png';

// Icon assets
import iconHome from '../assets/icon-home.png';
import iconPizza from '../assets/icon-pizza.png';
import iconHealthcare from '../assets/icon-healthcare.png';
import iconRetail from '../assets/icon-retail.png';
import iconAuto from '../assets/icon-auto.png';

const FractionalCMO = () => {
  return (
    <section className="fractional-cmo-section">
      <div className="fractional-cmo-container top-section">
        
        {/* NEW: Top Title & Paragraph */}
        <div className="cmo-text text-center">
          <h2>Are You A Local Business Looking to Outrank the Competition?</h2>
          <p>
            Our team are experts in running local advertising for your service business to get you in front of customers.
            We’ll get them calling, and once you close them, we’ll help make them brand advocates spreading word of mouth
            to new customers with reputation management.
          </p>

          <p>
            Take our <strong>FREE</strong> quiz by clicking the link below and get your <strong>Local SEO Scorecard!</strong>
          </p>

          <a
              href="https://birdeye.com/scan-business/?partnerid=174423001445005"
              className="cmo-button"
              target="_blank"
              rel="noopener noreferrer"
          >
            Get Your FREE Local SEO Audit
          </a>
          </div>
        </div>

        {/* NEW: Industries Section */}
         <div className="fractional-cmo-container middle-section">
        <div className="industries-section text-center">
          <h2>The Industries We Work With</h2>
          <div className="industry-icons">
            <div className="industry-item">
              <img src={iconHome} alt="Home Services" />
              <p>Home Services</p>
            </div>
            <div className="industry-item">
              <img src={iconPizza} alt="Restaurants" />
              <p>Restaurants</p>
            </div>
            <div className="industry-item">
              <img src={iconHealthcare} alt="Healthcare" />
              <p>Healthcare</p>
            </div>
            <div className="industry-item">
              <img src={iconRetail} alt="Retail" />
              <p>Retail</p>
            </div>
            <div className="industry-item">
              <img src={iconAuto} alt="Automotive" />
              <p>Automotive</p>
            </div>
          </div>
        </div>
        </div>

        {/* Existing Fractional CMO Content */}
        <div className="fractional-cmo-container bottom-section">
        <div className="cmo-text">
          <h2>What is a Fractional CMO and Is It Right For My Business?</h2>
          <p>
            A Fractional CMO is a seasoned marketing executive who provides expert leadership on a part-time or project basis, perfect for companies that don't need a full-time Chief Marketing Officer. 
            By outsourcing this role, your business gains access to top-tier strategic insight and leadership without the overhead of a full-time hire.
            This approach ensures you get high-quality expertise tailored to your needs while staying cost-effective, freeing up resources to invest directly into growth-driving initiatives.
          </p>
          <h3>
            Faster product launches, better marketing strategy, all at an affordable price over hiring a full-time CMO.
            <span className="cmo-icon-wrapper">
              <img src={cmoIcon} id="cmoIcon" alt="Fractional CMO Icon" />
            </span>
          </h3>
        </div>
        </div>

      
    </section>
  );
};

export default FractionalCMO;

